import { buildCsv, csvEscape } from "./csvDownload";

export type TrafficRow = {
  key: string;
  label: string; // Date label
  excursionists: number;
  destination: number;
  total: number; // total visitors
  available: number; // Nuitées disponibles
  occupied: number; // Nuitées occupées
  occupancy: string | number; // percentage string (e.g., "55.23")
};

type HotelSection = {
  names: string[];
  position?: "after";
};

export function buildTrafficCsv(
  rows: TrafficRow[],
  hotelSection?: HotelSection
): string {
  const headers = [
    "Date",
    "Excursionniste",
    "Destination",
    "Total de personnes",
    "Nuitées disponibles",
    "Nuitées occupées",
    "Taux d'occupation",
  ];

  const data = rows.map((r) => [
    r.label,
    r.excursionists,
    r.destination,
    r.total,
    r.available,
    r.occupied,
    typeof r.occupancy === "string" ? `${r.occupancy}%` : `${r.occupancy}%`,
  ]);

  const tableCsv = buildCsv(headers, data);

  if (!hotelSection || !hotelSection.names || hotelSection.names.length === 0) {
    return tableCsv;
  }

  // Append hotels list after the table
  const header = csvEscape("Hôtels inclus");
  const lines = hotelSection.names.map((n) => csvEscape(n)).join("\n");
  return `${tableCsv}\n\n${header}\n${lines}`;
}
